goog.provide('el8.appchart.dialog.referralHistory');

goog.require('el8.model.base');
goog.require('el8.uiwidget.NewDialog');
goog.require('el8.template.appchart.dialog.referralHistory');

el8.appchart.dialog.referralHistory = (function() {

    var referralOrders = null;

    var that = new el8.uiwidget.NewDialog({
        title: 'Referral History', // gets over-ridden each time shown
        modal: true,
        autoHeight: false,
        width: 600,
        height: 500,
        contentFn: function() { return ''; },
        showXButton: true
    });

    var super_show = that.show;
    that.show = function(spec) {

        referralOrders = spec.referralOrders || [];
        var specialtyName = referralOrders.length ? referralOrders[0].getSpecialtyName() : '';

        super_show.call(that);

        var referralOrdersObj = referralOrders.map(el8.model.toSoyMapFn);
        that.setContent(
            el8.template.appchart.dialog.referralHistory.content({
                specialtyName : specialtyName || '(no specialty indicated)',
                referralOrders : referralOrdersObj
            })
        );
    };

    var super_hide = that.hide;
    that.hide = function() {
        referralOrders = null;
        that.getContentElt().empty();
        super_hide.call(that);
    };

    return that;

})();

